// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import 'bootstrap/dist/css/bootstrap.css'
import '../static/assets/css/offcanvas.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/utils/vue-popper'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import Icon from 'vue2-svg-icon/Icon.vue'
import VueClipboard from 'vue-clipboard2'

import 'bootstrap/dist/js/bootstrap.bundle.js'
import '../static/assets/js/offcanvas.js'

import App from './App'
import router from './router'
import Axios from 'axios'

import store from './store'

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.component('icon', Icon)
Axios.interceptors.request.use(
  config => {
    config.baseURL = 'https://booking.adun.live'
    // config.baseURL = 'http://192.168.1.68:8080'
    // config.baseURL = 'https://192.168.10.2:17023'
    return config
  },
  err => {
    return Promise.reject(err)
  })
Vue.prototype.$ajax = Axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js